// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"24":"2cff0cdb","55":"2cff0cdb","176":"2cff0cdb","188":"2cff0cdb","346":"2cff0cdb","822":"2cff0cdb"}[chunkId] + ".chunk.css";
};